<ion-content>

  <ion-spinner></ion-spinner>

</ion-content>